import { Box, styled } from '@mui/material';

export const FadeContainer = styled(Box)<{ visible: number; time: number }>(({ visible, time }) => ({
  opacity: visible ? 1 : 0,
  transition: `opacity ${time}s ease`,
}));
